import { render } from "./NotRobotCheck.vue?vue&type=template&id=1a891f10&scoped=true"
import script from "./NotRobotCheck.vue?vue&type=script&lang=js"
export * from "./NotRobotCheck.vue?vue&type=script&lang=js"

import "./NotRobotCheck.vue?vue&type=style&index=0&id=1a891f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a891f10"]])

export default __exports__